import * as Msal from 'msal';
import { environment } from './environment';

export const msalConfig: Msal.Configuration = {
  auth: {
    clientId: environment.clientId, // This is your client ID
    authority: 'https://login.microsoftonline.com/72f988bf-86f1-41af-91ab-2d7cd011db47/' // This is your tenant info
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: true
  }
};

export const requestObject: Msal.AuthenticationParameters = {
  scopes: [environment.clientScopes]
};

export const graphConfig = {
  graphMeEndpoint: 'https://graph.microsoft.com/v1.0/me'
};
